export function cn(...classes: (string | undefined | null | false)[]) {
	return classes.filter(Boolean).join(' ');
}

export function formatDate(date: Date | string): string {
	const d = typeof date === 'string' ? new Date(date) : date;
	return d.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
}

export function formatDateTimeLocal(date: Date | string, timezone = 'America/Los_Angeles'): string {
	const d = typeof date === 'string' ? new Date(date) : date;
	return d.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		timeZone: timezone,
		timeZoneName: 'short'
	});
}

export function formatTimeLocal(date: Date | string, timezone = 'America/Los_Angeles'): string {
	const d = typeof date === 'string' ? new Date(date) : date;
	return d.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		timeZone: timezone,
		timeZoneName: 'short'
	});
}

export function formatMeetingTime(
	startTime?: string,
	endTime?: string,
	timezone = 'America/Los_Angeles'
): string {
	if (!startTime) return '';

	const formatTime = (timeStr: string) => {
		const [hours, minutes] = timeStr.split(':');
		const date = new Date();
		date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
		return date.toLocaleTimeString('en-US', {
			hour: 'numeric',
			minute: '2-digit',
			timeZone: timezone
		});
	};

	if (endTime) {
		return `${formatTime(startTime)} - ${formatTime(endTime)}`;
	}

	return formatTime(startTime);
}
